export default "__VITE_ASSET__C$GargVP__"